import axiosInstance from "./axiosInstance";
import queryString from "query-string"

const adminService = {
  createConnection,
  getConnection,
  loginAdmin,
  changeAdminPassword,
  getUser,
  updateConnection,
  uploadCsvBulkData,
  deleteUserConnection,
  changeAdminPasscode,
  deleteUser,
  updateUserPassword
};

async function createConnection(name) {
  return await axiosInstance.post(`/connection/create-connection`, { name });
}
async function getConnection() {
  return await axiosInstance.get(`/connection/get-connections`);
}

async function loginAdmin(email, password) {
  return await axiosInstance.post(`/admin/login`, { email, password });
}
async function changeAdminPassword(oldPassword, password) {
  return await axiosInstance.put(`/admin/change-admin-password`, {
    oldPassword,
    password,
  });
}

async function changeAdminPasscode(old_passcode, passcode) {
  return await axiosInstance.put(`/admin/change-admin-passcode`, {
    old_passcode,
    passcode,
  });
}

async function getUser(queries) {
  let query = queryString.stringify(queries);
  return await axiosInstance.get(`/admin/get-users?` + query);
}

async function updateConnection(connectionId, formData) {
  return await axiosInstance.put(
    `/connection/update-connection/${connectionId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
async function deleteUserConnection(id) {
  return await axiosInstance.delete(`/connection/delete-connection/${id}`);
}
async function deleteUser(id) {
  return await axiosInstance.delete(`/admin/delete-user/${id}`);
}
async function updateUserPassword(data) {
  return await axiosInstance.put(`/admin/update-user-password/${data.userId}`, data);
}
async function uploadCsvBulkData(data) {
  return await axiosInstance.post(`/admin/import-csv-bulk-data`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export default adminService;
